import { db } from '../../../firebase';
import { collection, onSnapshot as firestoreOnSnapshot } from 'firebase/firestore';

const ZERO_EFFORT_COLLECTIONS = {
  interactionPrimitives: 'assistantInteractionPrimitives',
  approvalRequests: 'assistantApprovalRequests',
  effectReceipts: 'assistantEffectReceipts',
  futureActionCommitments: 'assistantFutureActionCommitments',
};

function getZeroEffortCollection(userId, collectionName) {
  if (!userId) {
    throw new Error('userId is required');
  }

  return collection(db, 'users', userId, collectionName);
}

function subscribeToZeroEffortCollection(userId, collectionName, onUpdate, onError) {
  const col = getZeroEffortCollection(userId, collectionName);
  return firestoreOnSnapshot(
    col,
    (snapshot) => {
      onUpdate(
        snapshot.docs.map((docSnapshot) => ({
          id: docSnapshot.id,
          ...docSnapshot.data({ serverTimestamps: 'estimate' }),
        }))
      );
    },
    (error) => {
      if (onError) onError(error);
    }
  );
}

export function subscribeToInteractionPrimitives(userId, onUpdate, onError) {
  return subscribeToZeroEffortCollection(
    userId,
    ZERO_EFFORT_COLLECTIONS.interactionPrimitives,
    onUpdate,
    onError
  );
}

export function subscribeToApprovalRequests(userId, onUpdate, onError) {
  return subscribeToZeroEffortCollection(
    userId,
    ZERO_EFFORT_COLLECTIONS.approvalRequests,
    onUpdate,
    onError
  );
}

export function subscribeToEffectReceipts(userId, onUpdate, onError) {
  return subscribeToZeroEffortCollection(
    userId,
    ZERO_EFFORT_COLLECTIONS.effectReceipts,
    onUpdate,
    onError
  );
}

export function subscribeToFutureActionCommitments(userId, onUpdate, onError) {
  return subscribeToZeroEffortCollection(
    userId,
    ZERO_EFFORT_COLLECTIONS.futureActionCommitments,
    onUpdate,
    onError
  );
}
